// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "4132ba3658707eda5d52b18da4c08db2" + ".js";
};